export default __webpack_public_path__ + "static/sketchbook-34e97a986a17cb5a165c4132e0e1444e.svg";